/** Uppercase alphanumeric form used for registry CPF/CNPJ storage and comparison. */
export const normalizeDocument = (value: string): string => value.toUpperCase().replace(/[^A-Z0-9]/g, '');
